// https://medium.freecodecamp.org/scaling-your-redux-app-with-ducks-6115955638be

import authReducer from "./reducer";

// export { default as authSelectors } from './selectors'
// export { default as authOperations } from './operations'
// export { default as authTypes } from './types'

export default authReducer;
